var app = angular.module("leonardo");

var ReportsDocumentList = function ($scope, $controller, $state, $filter, ngDialog, ReportService, FilterService,
                                    DynamicFormRestService, PropertyService) {

  $controller('ReportsBaseController', { $scope: $scope });

  $scope.reports_missing = {};
  $scope.reports_missing.folderRequirement = [];
  $scope.reports_missing.expiringFiles = [];
  $scope.missing_documents = $state.current.missing_documents;
  $scope.title = $scope.missing_documents ? 'Missing Documents Reports' : 'Existing Documents Reports';
  $scope.report_type = $scope.missing_documents ?
    ReportService.TYPE_MISSING_DOCUMENTS : ReportService.TYPE_EXISTING_DOCUMENTS;
  $scope.fieldsReport = ReportService.fieldsDocumentsReport;

  $scope.missing_documents_models = {
    DOCUMENT_FOLDER_REQUIREMENT: 'DocumentFolderRequirement',
    DOCUMENT_FOLDER_FILE: 'DocumentFolderFile'
  };

  $scope.resetFields = function () {
    if (FilterService.hasFilter('fields_active')) {
      $scope.fields_active = FilterService.getFilter('fields_active').split(',');
    }
    else{
      $scope.fields_active = ['name', 'portfolio', 'property', 'action_item'];
      if($scope.missing_documents){
        $scope.fields_active.push('expiration');
      }
    }
    if (FilterService.getFilter('group_by') === 'account') {
      if (!_.contains($scope.fields_active, 'property')) {
        $scope.fields_active.unshift('property');
      }
      if (!_.contains($scope.fields_active, 'portfolio')) {
        $scope.fields_active.unshift('portfolio');
      }
    }
    if ((FilterService.getFilter('group_by') === 'portfolio') || FilterService.getFilter('group_by') === 'group') {
      if (!_.contains($scope.fields_active, 'property')) {
        $scope.fields_active.unshift('property');
      }
    }
  };

  $scope.getFieldValue = function (report, field) {
    var html = '';
    switch (field) {
      // case 'expiration':
      //   html = moment(report[field]).format('MMM DD, YYYY');
      //   return html;
      case 'created':
        html = '';
        if (angular.isArray(report[field])) {
          angular.forEach(report[field], function (date) {
            html += '<span class="date-multi">' + moment(date).format('MMM DD, YYYY') + '</span>';
          });
        }
        else if (report[field]) {
          html = moment(report[field]).format('MMM DD, YYYY');
        }
        return html;
      case 'secure_share_url':
        return '<a href="' + report[field] + '" target="_blank">' + report[field] + '</a>';
      case 'dynamic_form':
        html = '';
        if (report.dynamic_form) {
          if (!angular.isArray(report.dynamic_form)) {
            html = '<span>' + report.dynamic_form + '</span>';
          }
          else {
            angular.forEach(report.dynamic_form, function (dynamic_form) {
              html += '<span>' + dynamic_form + '</span>';
            });
          }
        }
        return html;
      case 'account':
      case 'portfolio':
      case 'action_item':
      case 'property':
        return report[field] ? report[field].name : '';
      case 'expired':
      case 'locked':
      case 'show_warning':
        return report[field] ? 'True' : 'False';
      case 'groups':
      case 'managed_by':
        html = '';
        if (angular.isArray(report[field])) {
          angular.forEach(report[field], function(element){
            html += '<span>' + element.name +'</span>';
          });
          return html;
        }
        else {
          if (report[field]) {
            html = report[field].name;
            return html;
          }
          html = (field === 'managed_by') ? 'Only Owner' : '';
          return html;
        }
      default:
        return report[field];
    }
  };

  $scope.openDynamicFormDialog = function (report, dynamic_form_data_id) {
    PropertyService.get(report.property.id).then(function (property) {
      if (dynamic_form_data_id) {
        angular.forEach(report.dynamic_form_data, function (data) {
          if (data.id == dynamic_form_data_id) {
            ngDialog.openConfirm({
              template: 'views/templates/dialog/task/dynamic-form-react.html',
              className: 'ngdialog-theme-default ngdialog-dynamic-form',
              controller: 'TaskDynamicFormDialogReact',
              resolve: {
                formObj: [function () {
                  return data.dynamic_form;
                }],
                formDataObj: ['DynamicFormDataRestService', function (DynamicFormDataRestService) {
                  return DynamicFormDataRestService.get(data.id);
                }]
              },
              data: {
                task: report,
                approvalStatus: false,
                property: property,
                mode: 'read',
                print: true,
              }
            }).then(function (result) {
              callback(result);
            });
          }
        });
      }
      else {
        ngDialog.openConfirm({
          template: 'views/templates/dialog/task/dynamic-form-react.html',
          className: 'ngdialog-theme-default ngdialog-dynamic-form',
          controller: 'TaskDynamicFormDialogReact',
          resolve: {
            formObj: [function () {
              return report.dynamic_form_data.dynamic_form;
            }],
            formDataObj: ['DynamicFormDataRestService', function (DynamicFormDataRestService) {
              return DynamicFormDataRestService.get(report.dynamic_form_data.id);
            }]
          },
          data: {
            task: report,
            approvalStatus: false,
            property: property,
            mode: 'read',
            print: true,
          }
        }).then(function (result) {
          callback(result);
        });
      }
    });
  };

  $scope.getFieldClasses = function (field) {
    var classes = [];
    switch (field) {
      case 'action_item':
      case 'name':
      case 'secure_share_url':
        classes.push('field-name');
        break;
      case 'note':
        classes.push('field-note');
        break;
      case 'expiration':
      case 'created':
        classes.push('date-multi-head');
        break;
    }
    return classes;
  };

  $scope.getIndexMissing = function (id, model){
    var index = -1;
    var array = model === $scope.missing_documents_models.DOCUMENT_FOLDER_REQUIREMENT ? $scope.reports_missing.folderRequirement : $scope.reports_missing.expiringFiles;
    angular.forEach(array, function (value, key) {
      if (value.id === id) {
        index = key;
      }
    });
    return index;
  };

  $scope.typeIsExpanded = function (type) {
    return ($scope.typeExpanded === type);
  };

  $scope.toggleType = function (type) {
    $scope.typeExpanded = ($scope.typeExpanded === type) ? null : type;
  };

  $scope.groupReports = function(data) {
    if (data.results) {
      $scope.reports = data.results ? data.results : data;
      if (data.results.info_data) {
        $scope.info_data = data.results.info_data;
      }
    }
    else {
      $scope.reports = data;
    }

    $scope.reportsGrouped = [];
    $scope.reports_missing = {};
    $scope.reports_missing.folderRequirement = [];
    $scope.reports_missing.expiringFiles = [];
    angular.forEach($scope.reports, function (value) {
      var id = 'ungroup';
      var name = 'No group';
      var array_by_name = [{id: id, name: name}];

      switch (FilterService.getFilter('group_by')) {
        case 'account':
          if (value.account) {
            id = value.account.id;
            name = value.account.name;
            array_by_name = $scope.accounts_by_name;
          }
          break;
        case 'portfolio':
          if (value.portfolio) {
            id = value.portfolio.id;
            name = value.portfolio.name;
            array_by_name = $scope.portfolios_by_name;
          }
          break;
        case 'property':
          if (value.property) {
            id = value.property.id;
            name = value.property.name;
            array_by_name = $scope.properties_by_name;
          }
          break;
        case 'group':
          if (value.groups && value.groups.length > 0) {
            id = [];
            name = [];
            array_by_name = [];
            angular.forEach(value.groups, function (group) {
              updateDocuemntGroupCase(group, id, name, array_by_name);
            });
          }
          else if (value.property && value.property.groups && (value.property.groups.length > 0)) {
            id = [];
            name = [];
            array_by_name = [];
            angular.forEach(value.property.groups, function (group) {
              updateDocuemntGroupCase(group, id, name, array_by_name);
            });
          }
          else if (value.portfolio && value.portfolio.groups && (value.portfolio.groups.length > 0)) {
            id = [];
            name = [];
            array_by_name = [];
            angular.forEach(value.portfolio.groups, function (group) {
              if(FilterService.hasFilter('group_reports')){
                if(_.contains(FilterService.getFilter('group_reports').toString().split(','), group.id.toString())){
                  id.push(group.id);
                  name.push(group.name);
                  array_by_name.push({id: group.id, name: group.name});
                }
              }else{
                id.push(group.id);
                name.push(group.name);
                array_by_name.push({id: group.id, name: group.name});
              }
            });
          }
          else {
            id = 'no_group';
            name = 'No group';
            array_by_name.push({id: id, name: name});
          }
          break;
        case 'managed_by':
          if (value.managed_by) {
            if (angular.isArray(value.managed_by)) {
              id = [];
              name = [];
              array_by_name = [];
              angular.forEach(value.managed_by, function (manager) {
                id.push(manager.id);
                name.push(manager.name);
                array_by_name.push({id: manager.id, name: manager.name});
              });
            }
            else {
              id = value.managed_by.id;
              name = value.managed_by.name;
              array_by_name = [value.managed_by];
            }
          }
          else {
            id = 'only_owner';
            name = 'Only Owner';
            array_by_name = [{id: id, name: name}];
          }
          break;
      }
      if (angular.isArray(id)) {
        angular.forEach(array_by_name, function (value_manager) {
          if ($scope.getIndex(value_manager.id) < 0) {
            $scope.reportsGrouped.push({id: value_manager.id, name: value_manager.name, reports: []});
          }
          $scope.reportsGrouped[$scope.getIndex(value_manager.id)].reports.push(value);
        });
        if ($scope.missing_documents) {
          if (value.model ===  $scope.missing_documents_models.DOCUMENT_FOLDER_REQUIREMENT) {
            angular.forEach(array_by_name, function(value_manager) {
              if ($scope.getIndexMissing(value_manager.id, value.model) < 0) {
                $scope.reports_missing.folderRequirement.push({ id: value_manager.id, name: value_manager.name, reports: [] });
              }
              $scope.reports_missing.folderRequirement[$scope.getIndexMissing(value_manager.id, value.model)].reports.push(value);
            });
          } else {
            angular.forEach(array_by_name, function(value_manager) {
              if ($scope.getIndexMissing(value_manager.id, value.model) < 0) {
                $scope.reports_missing.expiringFiles.push({ id: value_manager.id, name: value_manager.name, reports: [] });
              }
              $scope.reports_missing.expiringFiles[$scope.getIndexMissing(value_manager.id, value.model)].reports.push(value);
            });
          }
        }
      }
      else {
        if ($scope.getIndex(id) < 0) {
          $scope.reportsGrouped.push({id: id, name: name, reports: []});
        }

        $scope.reportsGrouped[$scope.getIndex(id)].reports.push(value);
        if ($scope.missing_documents) {
          if (value.model ===  $scope.missing_documents_models.DOCUMENT_FOLDER_REQUIREMENT) {
            if ($scope.getIndexMissing(id, value.model) < 0) {
              $scope.reports_missing.folderRequirement.push({ id: id, name: name, reports: [] });
            }
            $scope.reports_missing.folderRequirement[$scope.getIndexMissing(id, value.model)].reports.push(value);
          } else {
            if ($scope.getIndexMissing(id, value.model) < 0) {
              $scope.reports_missing.expiringFiles.push({ id: id, name: name, reports: [] });
            }
            $scope.reports_missing.expiringFiles[$scope.getIndexMissing(id, value.model)].reports.push(value);
          }
        }
      }

      if ($scope.reports_missing.folderRequirement.length === 1) {
        $scope.groupExpanded = $scope.reports_missing.folderRequirement[0].id;
      }
      else {
        $scope.reports_missing.folderRequirement = $filter('orderBy')($scope.reports_missing.folderRequirement, 'name');
      }

      if ($scope.reports_missing.folderRequirement.length === 1) {
        $scope.groupExpanded = $scope.reports_missing.folderRequirement[0].id;
      }
      else {
        $scope.reports_missing.expiringFiles = $filter('orderBy')($scope.reports_missing.expiringFiles, 'name');
      }


      if ($scope.reportsGrouped.length === 1) {
        $scope.groupExpanded = $scope.reportsGrouped[0].id;
      }
      else {
        $scope.reportsGrouped = $filter('orderBy')($scope.reportsGrouped, 'name');
      }
    });
  };

  function updateDocuemntGroupCase(group, id, name, array_by_name) {
    if (FilterService.hasFilter('group_reports')) {
      if (_.contains(FilterService.getFilter('group_reports').toString().split(','), group.id.toString())) {
        id.push(group.id);
        name.push(group.name);
        array_by_name.push({ id: group.id, name: group.name });
      }
    } else {
      id.push(group.id);
      name.push(group.name);
      array_by_name.push({ id: group.id, name: group.name });
    }
  }

};

app.controller('ReportsDocumentList', ['$scope', '$controller', '$state', '$filter', 'ngDialog', 'ReportService',
  'FilterService', 'DynamicFormRestService', 'PropertyService', ReportsDocumentList]);
